import Hero06 from "./Hero06";
import Faq06 from "./Faq06";

import SeoHead from "../../../../seo/SeoHead";
import {
  FAQ_PAGE_DESCRIPTION,
  FAQ_PAGE_TITLE,
} from "../../../../seo/siteConfig";

function main() {
  return (
    <div>
      <SeoHead
        title={FAQ_PAGE_TITLE}
        description={FAQ_PAGE_DESCRIPTION}
        path="/faq"
      />
      <Hero06 />
      <Faq06 />
    </div>
  );
}

export default main;
